import { render, staticRenderFns } from "./comp-play.vue?vue&type=template&id=29615fbe&scoped=true&lang=pug&"
import script from "./comp-play.vue?vue&type=script&lang=js&"
export * from "./comp-play.vue?vue&type=script&lang=js&"
import style0 from "./comp-play.vue?vue&type=style&index=0&id=29615fbe&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29615fbe",
  null
  
)

export default component.exports